import React, { useEffect } from 'react'
import Typewriter from 'typewriter-effect'
import usePageContext from '../../Page/context'
import { getCloudinaryImageUrl } from '../../../../utils'

const textSmallBaseStyle = 'font-swinton font-normal text-[19px] leading-none tracking-[-0.05em]'
const textBodyStyle =
  'text-[30px] leading-[1] font-bold tracking-[-0.05em] text-center font-abcd text-[#1E1E1E] uppercase'

const Desktop = (props: any) => {
  // Theme
  const { dispatch } = usePageContext()

  const [isThemeSet, setIsThemeSet] = React.useState(false)

  useEffect(() => {
    if (!isThemeSet) {
      dispatch({
        type: 'SET_THEME',
        payload: 'black'
      })
      setIsThemeSet(true)
    }
  }, [isThemeSet, dispatch])

  return (
    <div className='pt-[200px]'>
      <div className='flex flex-col items-center'>
        <div className='w-full lg:w-2/3 2xl:w-2/3 flex flex-col items-center'>
          <div className='w-full bg-white'>
            <div className='flex justify-center'>
              <div className='w-1/3 flex justify-center items-center'>
                <div className={textSmallBaseStyle} data-labelname='headerTextLeft'>
                  {props.headerTextLeft}
                </div>
              </div>
              <div className='w-1/3 flex justify-center items-center'>
                <div className={textSmallBaseStyle} data-labelname='headerTextCenter'>
                  {props.headerTextCenter}
                </div>
              </div>
              <div className='w-1/3 flex justify-center items-center'>
                <div className={textSmallBaseStyle} data-labelname='headerTextRight'>
                  {props.headerTextRight}
                </div>
              </div>
            </div>
          </div>
          {props.headerLargeText && (
            <div
              data-labelname='headerLargeText'
              className={`text-center uppercase font-abcd font-extrabold text-[102.3px] leading-[78%] tracking-[-0.05em] mb-[100px] -mt-[6px]`}
            >
              <Typewriter
                onInit={(typewriter) => {
                  typewriter.typeString(props.headerLargeText).start()
                }}
              />
            </div>
          )}
        </div>
      </div>

      {(props.block2Text || props.block2TextBrief) && (
        <div className='flex flex-col items-center w-1/2 mx-auto -mb-[0.20vw]'>
          <div className='px-2'>
            <p className={`${textBodyStyle} mb-5 whitespace-pre-line`} data-labelname='block2Text'>
              {props.block2Text}
            </p>
            <p className={`${textBodyStyle} mb-0`} data-labelname='block2TextBrief'>
              {props.block2TextBrief}
            </p>
          </div>
        </div>
      )}

      {props?.block2Image?.data?.attributes?.url && (
        <div className='w-full relative'>
          <img
            src={getCloudinaryImageUrl(props?.block2Image?.data?.attributes?.url, 'q_auto,dpr_auto,f_auto,w_1920')} // Placeholder
            alt=''
            className='w-full'
          />
        </div>
      )}

      {props.block3Text && (
        <div className='flex flex-col items-center w-1/2 mx-auto -mt-[3px] -mb-[4px]'>
          <p className={`${textBodyStyle}`} data-labelname='block3Text'>
            {props.block3Text}
          </p>
        </div>
      )}

      {props?.block3Image?.data?.attributes?.url && (
        <div className='w-full relative'>
          <img
            src={getCloudinaryImageUrl(props?.block3Image?.data?.attributes?.url, 'q_auto,dpr_auto,f_auto,w_1920')} // Placeholder
            alt=''
            className='w-full'
          />
        </div>
      )}

      {props.block4Text && (
        <div className='text-center uppercase font-bold text-[70px] leading-[78%] tracking-tighter -mt-[3px] -mb-[4px] font-abcd text-[#1E1E1E] whitespace-pre-line'>
          {props.block4Text}
        </div>
      )}

      {props?.block4Image?.data?.attributes?.url && (
        <div className='w-full relative'>
          <img
            src={getCloudinaryImageUrl(props?.block4Image?.data?.attributes?.url, 'q_auto,dpr_auto,f_auto,w_1920')} // Placeholder
            alt=''
            className='w-full'
          />
        </div>
      )}
    </div>
  )
}

export default Desktop
